import React from "react";

export const AboutUs: React.FC<any> = () => {
    return (
        <React.Fragment>
          <div style={{ maxWidth: '900px', margin: '0 auto', paddingTop: '2rem' }}>
            {/* Header */}
            <h1 style={{ fontSize: '2.5rem', fontWeight: 'bold', marginBottom: '1rem', color: 'var(--ion-text-color, #1a1a1a)' }}>
              About WerkApp
            </h1>
            <p style={{ fontSize: '1.3rem', color: '#f4b41a', marginBottom: '2rem', fontWeight: '600' }}>
              A Network for Those Who Work
            </p>

            {/* Mission Section */}
            <section style={{ marginBottom: '3rem' }}>
              <h2 style={{ fontSize: '1.8rem', fontWeight: 'bold', marginBottom: '1rem', color: 'var(--ion-text-color, #1a1a1a)' }}>
                Our Mission
              </h2>
              <p style={{ fontSize: '1.1rem', lineHeight: '1.8', color: 'var(--ion-text-color, #333)', marginBottom: '1rem' }}>
                WerkApp was built to solve a simple but persistent problem: <strong>coordinating jobs 
                across a large team is time-consuming, error-prone, and easy to get wrong.</strong>
              </p>
              <p style={{ fontSize: '1.1rem', lineHeight: '1.8', color: 'var(--ion-text-color, #333)', marginBottom: '1rem' }}>
                We're not here to change the locker room culture. We're here to support it. WerkApp gives off duty schedulers the tools they need to manage details 
                effectively and officers an easy way get the extra work they want. It's a network where you can stay connected AND get things done.
              </p>
            </section>

            {/* The Story */}
            <section style={{ marginBottom: '3rem', backgroundColor: 'var(--ion-color-light, #f5f5f5)', padding: '2rem', borderRadius: '8px' }}>
              <h2 style={{ fontSize: '1.8rem', fontWeight: 'bold', marginBottom: '1rem', color: 'var(--ion-text-color, #1a1a1a)' }}>
                Why We Built This
              </h2>
              <p style={{ fontSize: '1.1rem', lineHeight: '1.8', color: 'var(--ion-text-color, #333)', marginBottom: '1rem' }}>
                Someone had to do it, because juggling hundreds of texts, missed messages, 
                double-bookings, and officers who never saw the post in time just doesn't make sense.
              </p>
              <p style={{ fontSize: '1.1rem', lineHeight: '1.8', color: 'var(--ion-text-color, #333)', marginBottom: '1rem' }}>
                Officers want more opportunities. Coordinators want a reliable system they can count on. WerkApp delivers both.
              </p>
              <p style={{ fontSize: '1.1rem', lineHeight: '1.8', color: 'var(--ion-text-color, #333)' }}>
                <strong>Notifications are timestamped. Every acceptance and status is tracked.</strong> The record is always 
                there—clean, complete, and easy to reference.
              </p>
            </section>

            {/* Value Proposition */}
            <section style={{ marginBottom: '3rem' }}>
              <h2 style={{ fontSize: '1.8rem', fontWeight: 'bold', marginBottom: '1rem', color: 'var(--ion-text-color, #1a1a1a)' }}>
                Why Detail Coordinators Choose WerkApp
              </h2>
              <ul style={{ fontSize: '1.1rem', lineHeight: '2', color: 'var(--ion-text-color, #333)', paddingLeft: '1.5rem' }}>
                <li><strong>Less admin time:</strong> Post a detail in seconds. Officers accept in one tap. No more group texts.</li>
                <li><strong>Easy adoption:</strong> A simple, intuitive system officers actually want to use. Onboarding takes minutes.</li>
                <li><strong>Mobile and web access:</strong> Coordinators can manage from mobile or the web. Officers access details on their phones.</li>
                <li><strong>Netwerk Power:</strong> The power of getting things done in a platform that is also your netwerk is all but unrecognized, until now.</li>
              </ul>
            </section>

            {/* It's Like Social Media, But Productive */}
            <section style={{ marginBottom: '3rem' }}>
              <h2 style={{ fontSize: '1.8rem', fontWeight: 'bold', marginBottom: '1rem', color: 'var(--ion-text-color, #1a1a1a)' }}>
                More Than Just Scheduling
              </h2>
              <p style={{ fontSize: '1.1rem', lineHeight: '1.8', color: 'var(--ion-text-color, #333)', marginBottom: '1rem' }}>
                WerkApp is a network for those who work. Officers build their professional network, stay connected 
                with opportunities, and manage their schedules—all in one place.
              </p>
              <p style={{ fontSize: '1.1rem', lineHeight: '1.8', color: 'var(--ion-text-color, #333)' }}>
                It's like social media... but productive. Less scrolling, more earning. Less drama, more opportunity. 
              </p>
              <p style={{ fontSize: '1.1rem', lineHeight: '1.8', color: 'var(--ion-text-color, #333)' }}>
                Will there be memes?   I mean... IDK. You're asking if people are gonna use this platform to send memes to each other just because it has the ability to send serious work related communications that are intended for productivity, but in a "social media"-like format? Maybe...
              </p>
            </section>

            {/* Contact */}
            <section style={{ marginBottom: '3rem', backgroundColor: '#1a1a1a', color: '#ffffff', padding: '2rem', borderRadius: '8px', textAlign: 'center' }}>
              <h2 style={{ fontSize: '1.8rem', fontWeight: 'bold', marginBottom: '1rem', color: '#f4b41a' }}>
                Get in Touch
              </h2>
              <p style={{ fontSize: '1.1rem', lineHeight: '1.8', marginBottom: '1rem' }}>
                Have questions? Want to see a demo? We're here to help.
              </p>
              <p style={{ fontSize: '1.1rem', fontWeight: '600', color: '#f4b41a' }}>
                Contact us: support@werkapp.app
              </p>
            </section>

            {/* Team Note */}
            <section style={{ marginBottom: '3rem', textAlign: 'center' }}>
              <p style={{ fontSize: '1rem', color: 'var(--ion-color-medium, #666)', fontStyle: 'italic' }}>
                WerkApp is designed and built by people who understand the unique challenges of 
                managing off-duty work. We're committed to making your job easier so you can do what you want.
              </p>
            </section>
          </div>
        </React.Fragment>
    )
};


